import {Injectable, inject} from '@angular/core'
import {EmbeddedStoreService} from '@service/embeddingService/embedded-store.service'
import {UMService} from './um.service'

/**
 * Variante embebida de `UMService`.
 *
 * @description
 * Lee `ums`, `umsOrder` y `allUms` desde el payload del host
 * (`EmbeddedStoreService.dataUms`) en lugar de `Tables.Info/Info_UMS`.
 */
@Injectable({
  providedIn: 'root',
})
export class UMEmbeddedService extends UMService {
  private readonly orderEmbbdedStoreService: EmbeddedStoreService = inject(EmbeddedStoreService)

  protected override getUmsData = async (): Promise<any> => this.orderEmbbdedStoreService.dataUms()
}
